import { Divider, FormControl, Grid, TextField, Typography,useTheme } from '@mui/material';
import React, { useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { payRateModStyles } from '../../PayRate/PayRateMod.styles';
import { useSelector } from 'react-redux';
import { selectPayRateGww } from 'store/redux-store/placement-mods/selectors';
import { RateSection } from './RateSection';
import { CancelledSection } from './CancelledSection';
import { billExNotes } from 'app/models/Placement/PlacementMods';
import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';

export const BillRateGwwMod = ({ isExpanded, isModEdit }: { isExpanded: boolean; isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { classes } = payRateModStyles({ isExpanded });
  const selectedNotes = useWatch<any[]>({ name: billExNotes });
  const getGwwBillRate = useSelector(selectPayRateGww);
  const [notesCharCount, setNotesCharCount] = useState(0);
  const maxNotesCharLimit = 1000;
  const theme= useTheme();

  const formatDropdownOptions = (options: { id: string; description: string }[]) => {
    if (options) {
      const newOptions = options.map(item => {
        return {
          ID: item.id,
          Description: item.description,
        };
      });
      return newOptions;
    }
    return [];
  };

  const { control, setValue, getValues } = useFormContext();

  const preFilledValue = getValues(billExNotes) || '';
  if (notesCharCount !== preFilledValue.length) {
    setNotesCharCount(preFilledValue.length);
  }

  const getNotesCharCount = () => {
    return (
      <span style={{ color: theme.palette.components.typography.color, display: 'flex', justifyContent: 'flex-end' }}>
        {`${notesCharCount}/${maxNotesCharLimit}`}
      </span>
    );
  };

  return (
    <Grid style={{ marginTop: '24px' }}>
      <Grid className={classes.divider}>
        <Divider />
      </Grid>
      <Grid>
        <Controller
          name={'billRateGww'}
          render={({field: { onChange, ...rest } }) => {
            return (
              <FormControl disabled={true}>
                <div className={classes.labelRow} style={{ paddingLeft: '0px', paddingTop: '24px', paddingBottom: '0px'}}>
                  <Typography component="span" className={classes.headings}>{`${t(
                    'placement.placementMods.guaranteedWorkWeek',
                  )}`}</Typography>
                </div>
                <Grid className={classes.flex}>
                  <RateSection isExpanded={isExpanded} isModEdit={isModEdit} />
                  <CancelledSection isExpanded={isExpanded} isModEdit={isModEdit} />
                </Grid>
                <Grid className={classes.flex}>
                  <Grid>
                    <Controller
                      control={control}
                      name={`gwwExceptions`}
                      render={({ field: { onChange, ...rest } }) => {
                        return (
                          <FormInputDropdown
                            inputValue={getValues('gwwExceptions') ?? []}
                            name={`gwwExceptions`}
                            label={t('placement.placementMods.exceptions')}
                            customClass={classes.exceptionDropdown}
                            multiple
                            useMenuItem
                            displayMenuTop
                            standard={true}
                            options={formatDropdownOptions(getGwwBillRate)}
                            handleChange={e => {
                              onChange(e);
                            }}
                            readOnly={!isModEdit}
                          ></FormInputDropdown>
                        )}
                      }
                    />
                  </Grid>
                  <Grid className={classes.factorMarginBillRate}>
                    <Controller
                      control={control}
                      name={billExNotes}
                      rules={{
                        maxLength: { value: 1000, message: t('notification.createTask.maxLimitLabel') },
                      }}
                      render={({ field: { onChange, ...rest } }) => (
                        <TextField
                          multiline
                          variant="filled"
                          className={classes.exceptionsInputs}
                          color="primary"
                          value={selectedNotes}
                          maxRows={5}
                          onChange={e => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= maxNotesCharLimit) {
                              setNotesCharCount(inputValue.length);
                              setValue(billExNotes, inputValue);
                              onChange(inputValue);
                            }
                          }}
                          id={billExNotes}
                          helperText={getNotesCharCount()}
                          InputProps={{
                            readOnly: !isModEdit,
                            style: {
                              pointerEvents: isModEdit ? 'auto' : 'none',
                              background: 'rgba(0,0,0, 0.04)',
                            },
                            sx: { fontSize: '14px' },
                          }}
                          label={`${t(`placement.placementMods.Notes`)}`}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </FormControl>
            );
          }}
        />
      </Grid>
    </Grid>
  );
};
